import React, { Component } from "react";

class NotFoundContainer extends Component {
  render() {
    return <h1>404 Page Not Found</h1>;
  }
}

export default NotFoundContainer;
